import React from 'react';
import type { Site } from '../../schemas/validation';
import { WebsiteLayout } from '../../components/WebsiteLayout';
import { LayoutComponents, processLayoutComponents } from '../WebsitePreview/LayoutComponents';
import type { PublicBlogLayout, PublicSiteSummary, SiteNavigationItem } from './types';

interface BlogLayoutWrapperProps {
  site: PublicSiteSummary | null;
  siteNavigation: SiteNavigationItem[];
  pageLayout: PublicBlogLayout | null;
  theme: unknown;
  showBranding: boolean;
  children: React.ReactNode;
}

export const BlogLayoutWrapper: React.FC<BlogLayoutWrapperProps> = ({
  site,
  siteNavigation,
  pageLayout,
  theme,
  showBranding,
  children,
}) => {
  if (!pageLayout?.components?.length || !site) {
    return <>{children}</>;
  }

  const { headerComponents, footerComponents } = processLayoutComponents(pageLayout.components);
  const website = site as unknown as Site;

  return (
    <WebsiteLayout
      website={website}
      navigation={siteNavigation}
      theme={theme}
      showBranding={showBranding}
    >
      <div id="top" />
      <LayoutComponents components={headerComponents} position="header" />
      {children}
      <LayoutComponents components={footerComponents} position="footer" />
    </WebsiteLayout>
  );
};
